import { useI18n } from '@affine/i18n';
import { NotificationIcon } from '@blocksuite/icons/rc';
import { useService } from '@toeverything/infra';
import clsx from 'clsx';

import { useDirectorBadgeCount } from '../../desktop/pages/workspace/director/model/use-director-counts';
import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { WorkbenchService } from '../../modules/workbench';
import * as styles from './notification-button.style.css';
import { useNavPrefixActive } from './use-nav-prefix-active';

/** Above this the badge reads "9+". */
const BADGE_CAP = 9;

/** How many Director items need the caller (published by `useDirectorCounts`); none at 0. The
 *  mobile tab bar places the same badge over its icon with `className`. */
export const DirectorBadge = ({
  count,
  className,
}: {
  count: number;
  className?: string;
}) => {
  const t = useI18n();
  if (count <= 0) return null;
  return (
    <div
      role="status"
      className={clsx(styles.badge, className)}
      aria-label={
        count === 1
          ? t['com.affine.pipe.director.tasks.delivery.badge-one']()
          : t['com.affine.pipe.director.tasks.delivery.badge']({
              n: String(count),
            })
      }
    >
      {count > BADGE_CAP ? `${BADGE_CAP}+` : count}
    </div>
  );
};

export const DirectorButton = () => {
  const t = useI18n();
  const workbench = useService(WorkbenchService).workbench;
  const active = useNavPrefixActive(workbench, '/director');
  const count = useDirectorBadgeCount();

  return (
    <MenuLinkItem
      icon={<NotificationIcon />}
      active={active}
      to="/director"
      postfix={<DirectorBadge count={count} />}
      postfixDisplay="always"
    >
      <span data-testid="pipe-director-nav">
        {t['com.affine.pipe.director.title']()}
      </span>
    </MenuLinkItem>
  );
};
